import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=622eb498&"
import script from "./Three.vue?vue&type=script&lang=js&"
export * from "./Three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports